import { render } from "./Composition.vue?vue&type=template&id=eb56f7e4&scoped=true"
import script from "./Composition.vue?vue&type=script&lang=js"
export * from "./Composition.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-eb56f7e4"

export default script